export default "__VITE_ASSET__$$bDcIRA__"